import React, { Component } from "react";
import PropTypes from "prop-types";

import anchorme from "anchorme";

import { PROJECT_HOME } from "App/Routes";
import placeholder_project from "images/core/placeholders/placeholder_project.png";
import placeholder_topic from "images/core/placeholders/placeholder_topic.jpg";
import "./Sidebar.css";
import Link from "components/shared/Link/Link";
import ShareGameDialog from "components/shared/Dialogs/ShareGameDialog/ShareGameDialog";

import sessionStorageService from "services/sessionStorageService";

const propTypes = {
  state: PropTypes.oneOf(["project", "project-secondary", "topic"]),
  projectId: PropTypes.number,
  projectName: PropTypes.string,
  projectDescription: PropTypes.string,
  projectImage: PropTypes.string,
  project: PropTypes.object,
  showTeams: PropTypes.bool,
  topicId: PropTypes.number,
  topicName: PropTypes.string,
  topicDescription: PropTypes.string,
  topicImage: PropTypes.string,
  isProjectPage: PropTypes.bool,
  showShareGameDialog: PropTypes.bool.isRequired,
  handleOpenShareGameDialog: PropTypes.func.isRequired,
  handleCloseShareGameDialog: PropTypes.func.isRequired,
  language: PropTypes.string
};
const defaultProps = {
  projectImage: placeholder_project,
  topicImage: placeholder_topic
};

class Sidebar extends Component {
  addAnchors(text) {
    // add anchor tags to links
    if (text) {
      text = anchorme(text, {
        exclude: urlObj => {
          urlObj.encoded = urlObj.encoded.replace(/%25/g, "%");
          return false;
        },
        attributes: [
          { name: "target", value: "blank" },
          { name: "class", value: "link default break-url" },
          { name: "rel", value: "external" }
        ]
      });
    }
    return text;
  }

  renderProject() {
    let anchoredProjectName = this.addAnchors(this.props.projectName);
    let anchoredProjectDescription = this.addAnchors(
      this.props.projectDescription
    );

    let projectImage = this.props.projectImage;

    switch (this.props.state) {
      case "topic":
        if (this.props.topicId) {
          return (
            <Link
              id="project-small"
              to={PROJECT_HOME.format(this.props.projectId)}
            >
              <div className="topic-bar table">
                <img
                  className="iconsmall verticalmargin-5 horizontalmargin-10 alignmiddle tablecell"
                  src={projectImage}
                  alt={this.props.projectName}
                />
                <div className="tablecell alignmiddle">
                  {this.props.projectName}
                </div>
              </div>
            </Link>
          );
        }
      /*
          Include the "falls through" comment below so that jshint/eslint can tell
          you are expecting this case to include no break; or return;
        */
      /* falls through */
      case "project":
      case "project-secondary":
        return (
          <div id="project" className="pure-g toppadding">
            {this.renderSidebarShareButton()}
            {this.props.showShareGameDialog && this.renderShareGameDialog()}
            <div className="pure-u-1">
              <div className="pure-u-1-2 imgcenter">
                <span className="square-image-wrapper bottommargin-10">
                  <span className="square-image circle">
                    <img src={projectImage} alt={this.props.projectName} />
                  </span>
                </span>
              </div>
              <h5
                className="textcenter"
                dangerouslySetInnerHTML={{ __html: anchoredProjectName }}
              />
              <p
                className="textcenter smalltext"
                dangerouslySetInnerHTML={{ __html: anchoredProjectDescription }}
              />
            </div>
          </div>
        );
      default:
        return null;
    }
  }

  renderTopic() {
    let anchoredTopicName = this.addAnchors(this.props.topicName);
    let anchoredTopicDescription = this.addAnchors(this.props.topicDescription);
    let topicImage = this.props.topicImage;

    switch (this.props.state) {
      case "topic":
        if (this.props.topicId) {
          return (
            <div id="topic" className="pure-g horizontalpadding">
              <div className="pure-u-1">
                <div className="pure-u-1-2 imgcenter">
                  <span className="square-image-wrapper bottommargin-10">
                    <span className="square-image circle">
                      <img src={topicImage} alt={this.props.topicName} />
                    </span>
                  </span>
                </div>
                <h5
                  className="textcenter"
                  dangerouslySetInnerHTML={{ __html: anchoredTopicName }}
                />
                <p
                  className="textcenter smalltext"
                  dangerouslySetInnerHTML={{ __html: anchoredTopicDescription }}
                />
              </div>
            </div>
          );
        } else {
          return null;
        }
      case "project":
      case "project-secondary":
      default:
        return null;
    }
  }

  renderSidebarShareButton() {
    if (this.props.project && this.props.project.projectShareLink) {
      return (
        <button
          className="button icon info inline"
          onClick={this.props.handleOpenShareGameDialog}
        >
          <i className="fas fa-share-alt"></i>
        </button>
      );
    } else {
      return null;
    }
  }

  renderShareGameDialog() {
    return (
      <ShareGameDialog
        showDialog={this.props.showShareGameDialog}
        handleCloseDialog={this.props.handleCloseShareGameDialog}
        projectId={this.props.projectId}
        project={this.props.project}
        language={this.props.language}
      />
    );
  }

  renderHideClasses() {
    const IS_640_DESKTOP_PROJECT =
      sessionStorageService.getItem("640_desktop_project") === "true"
        ? true
        : false;
    if (IS_640_DESKTOP_PROJECT && this.props.isProjectPage) {
      return " hide-below-md-640";
    } else if (this.props.isProjectPage) {
      return " hide-below-md";
    } else {
      return " hide-below-lg";
    }
  }

  render() {
    return (
      <div
        className={"sidebar-wrapper" + this.renderHideClasses()}
        style={{ width: "25%" }}
      >
        <div className="sidebar sidebarbg">
          <div className="horizontalpadding-10 on-lg-horizontalpadding bottompadding-floating-extended">
            {this.renderProject()}
            {this.renderTopic()}
          </div>
        </div>
      </div>
    );
  }
}

Sidebar.propTypes = propTypes;
Sidebar.defaultProps = defaultProps;

export default Sidebar;
